module.exports = __webpack_public_path__ + "imgs/other.9a95a8b163a7c1ead7f402235b89d22f.jpg";